import type { ViewKey } from '@dash/shared';

export function buildWsUrl(view: ViewKey, token?: string): string {
  const proto = window.location.protocol === 'https:' ? 'wss' : 'ws';
  const host = import.meta.env.DEV ? 'localhost:3700' : window.location.host;
  const url = new URL(`${proto}://${host}/ws`);
  url.searchParams.set('view', view);
  if (token) url.searchParams.set('token', token);
  return url.toString();
}
